import { useEffect, useState } from 'react';
import { Dialog, DialogContent, Box, Typography, IconButton, TextField } from '@mui/material';
import { MdClose } from 'react-icons/md';
import copy from 'copy-to-clipboard';

import Button from '@/components/Common/Button';

interface CopyOnboardingUrlModalProps {
  open: boolean;
  onClose: () => void;
  businessName: string;
  contactPerson: string;
  onboardingUrl: string;
}

export default function CopyOnboardingUrlModal({
  open,
  onClose,
  businessName,
  contactPerson,
  onboardingUrl
}: CopyOnboardingUrlModalProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!open) {
      setCopied(false);
    }
  }, [open]);

  const handleCopy = () => {
    if (!onboardingUrl) return;
    copy(onboardingUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 520
        }
      }}
    >
      <DialogContent sx={{ p: 3 }}>
        <Box display='flex' justifyContent='space-between' alignItems='center' mb={2.5}>
          <Typography fontWeight={600} fontSize={18} color='text.primary'>
            Copy Onboarding URL
          </Typography>
          <IconButton size='small' onClick={onClose} aria-label='Close'>
            <MdClose size={22} />
          </IconButton>
        </Box>

        <Box
          sx={{
            backgroundColor: '#F5F5F5',
            borderRadius: 2,
            p: 2,
            mb: 3,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gap: 2
          }}
        >
          <Box>
            <Typography
              fontSize={11}
              fontWeight={500}
              color='#9CA3AF'
              letterSpacing={0.5}
              textTransform='uppercase'
              mb={0.5}
            >
              Business Name
            </Typography>
            <Typography fontWeight={600} fontSize={14} color='text.primary'>
              {businessName || 'N/A'}
            </Typography>
          </Box>
          <Box>
            <Typography
              fontSize={11}
              fontWeight={500}
              color='#9CA3AF'
              letterSpacing={0.5}
              textTransform='uppercase'
              mb={0.5}
            >
              Contact Person
            </Typography>
            <Typography fontWeight={600} fontSize={14} color='text.primary'>
              {contactPerson || 'N/A'}
            </Typography>
          </Box>
        </Box>

        <Box display='flex' gap={1.5} alignItems='flex-start'>
          <TextField
            label='Onboarding URL'
            value={onboardingUrl}
            fullWidth
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            sx={{
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#ececec'
                }
              },
              '& .MuiInputBase-input': {
                color: '#6B7280',
                fontSize: 14
              }
            }}
          />
          <Button
            variant='contained'
            onClick={handleCopy}
            disabled={!onboardingUrl}
            sx={{
              minWidth: 88,
              height: 56,
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 600,
              fontSize: 14,
              flexShrink: 0
            }}
          >
            {copied ? 'Copied!' : 'Copy'}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
